import type { IssueStatus, Mastery } from "@/types/lex";

export const STATUS_LABEL: Record<IssueStatus, string> = {
  done: "Done",
  "in-progress": "In progress",
  "due-review": "Due review",
  locked: "Upcoming",
};

export const STATUS_DOT: Record<IssueStatus, "moss" | "amber" | "indigo" | "empty"> = {
  done: "moss",
  "in-progress": "amber",
  "due-review": "indigo",
  locked: "empty",
};

export const MASTERY_DOT: Record<Mastery, "moss" | "amber" | "red" | "empty"> = {
  known: "moss",
  learning: "amber",
  unknown: "red",
  untouched: "empty",
};
